module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-pro-onboarding/zero-states/sequences.png"